export default __webpack_public_path__ + "static/media/chaqueta-rockera-mujer.7e64e37b.png";